import { useFeatureFlagEnabled } from 'posthog-js/react';

import { hasAppAccess } from 'entities/user/lib/hasAppAccess';
import { useAuth } from 'shared/lib/auth/useAuth';
import { FeatureFlag } from 'shared/lib/features/common';

/**
 * Whether the assistant chat is available to this user: in the rollout, and past AuthGuard's
 * interstitials (its endpoints answer 403 for accounts that haven't been approved).
 *
 * Shared so the launcher, the dialog and the Inkeep widget can't disagree about it — when they did,
 * the dashboard showed two "Ask Truv AI" buttons stacked in the corner, each opening a different
 * chat (CL-6818). Screen width is no longer part of the answer: a phone opens the same chat as a
 * full-screen sheet, reached from the nav drawer rather than a floating pill (CL-6904).
 */
export const useAssistantEnabled = (): boolean => {
  const { user } = useAuth();
  const assistantEnabled = useFeatureFlagEnabled(FeatureFlag.AI_ASSISTANT);

  return hasAppAccess(user) && Boolean(assistantEnabled);
};
